module.exports = __webpack_public_path__ + "static/2018-mhooper72-logo-horizontal-gsuite-b1f069c1699df83aceff40669ca7cb53.png";